import { defineStore } from 'pinia';
import ApiService from '@/services/ApiService';
import { useResourceStore } from '@/store/ResourceStore';

export const useCollectionStore = defineStore('collection', {
  state () {
    return {
      filteredCollections: [],
      loading: false,
      downloadCID: null, // download collection id
      defaultCollectionData: {
        color: null,
        description: 'Enter Description',
        name: 'Enter Name',
        resourcePks: [],
        resources: [],
        subscriptions: [],
        tagIds: []
      }
    };
  },
  getters: {
    collections () { return this.filteredCollections; },
    selectedCollections () { return this.filteredCollections.filter(function (item) { return item.isSelected; }); },
    visibleCollections () {
      const collectionStore = useCollectionStore();
      const selectedCollections = collectionStore.selectedCollections;
      if (selectedCollections.length > 0) { return selectedCollections; }
      return collectionStore.collections;
    },
    isLoading () {
      return this.loading;
    },
    getDefaultCollectionData () {
      return this.defaultCollectionData;
    }
  },
  actions: {
    clearSelected () {
      this.selectedCollections.forEach((collection) => { collection.isSelected = false; });
    },
    async filterCollections (page, limit, searchText, orderBy, orderDescending) {
      this.loading = true;
      await ApiService.getCollections(page, limit, searchText, orderBy, orderDescending)
        .then(response => {

          let tempCollections = response.data;
          if (page !== 1) {
            this.filteredCollections.push(...tempCollections);
          } else {
            this.filteredCollections = tempCollections;
          }
          this.loading = false;
        })
        .catch(error => {
          throw (error);
        });
    },
    downloadCollectionZip (collection) {
      var items = collection.resources;
      const resourceStore = useResourceStore();
      if (items.length === 0) { return; }
      return resourceStore.downloadResourcesZip(items);
    },
    async addCollectionTags (tagId, collectionId, page, limit, searchText, orderBy, orderDescending) {
      return await ApiService.addCollectionTags(tagId, collectionId)
        .then(() => {
          this.filterCollections(page, limit, searchText, orderBy, orderDescending);
        })
        .catch((error) => {
          throw error;
        });
    },
    async deleteCollectionTags (tagId, collectionId, page, limit, searchText, orderBy, orderDescending) {
      return await ApiService.removeCollectionTags(tagId, collectionId)
        .then(() => {
          this.filterCollections(page, limit, searchText, orderBy, orderDescending);
        })
        .catch((error) => {
          throw error;
        });
    },
    // TODO: could be consolidated with TAGS/PERMISSIONS into a universal function
    getCollectionsById (ids) {
      if (ids === undefined) { return []; }
      let arr = [];
      this.collections.forEach((collection) => {
        if (ids.includes(collection.cID)) {
          arr.push(collection);
        }
      });
      return arr.sort((a, b) => a.name.localeCompare(b.name));
    },



  }
});